import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fd2149a&scoped=true&lang=pug&"
import script from "./script.ts?vue&type=script&lang=js&"
export * from "./script.ts?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=2fd2149a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2149a",
  null
  
)

export default component.exports